<!--
 * @Author: LiuMeiYu
 * @Date: 2023-02-01 21:41:52
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-03-15 15:55:07
 * @FilePath: \nivara\src\views\set\components\setProfileView.vue
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
-->
<template>
  <div class="set-profile-container" v-loading="userInfoLoading">
    <div class="set-item set-profile-photo">
      <div class="set-profile-avatar">
        <el-image
          :src="
            userInfoData.avatar ||
              require('../../../assets/images/default_avatar.png')
          "
        />
        <div class="profile-photo">Profile Photo</div>
      </div>
      <el-button class="btn-edit" @click="openUpdateAvatar">Edit</el-button>
    </div>
    <div class="set-item set-username">
      <div class="set-profile-username">
        Nickname
        <div class="profile-username">{{ userInfoData.nickname }}</div>
      </div>
      <el-button class="btn-edit" @click="openUpdateUsername">Edit</el-button>
    </div>
    <Popup title="My Avatar" ref="updateAvatarRef">
      <template #content>
        <div class="update-username-content" v-loading="uploadLoading">
          <el-upload
            class="sell-now-upload"
            action="#"
            list-type="picture-card"
            :limit="1"
            :auto-upload="false"
            :on-change="uploadObs"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            multiple
          >
            <el-icon><Plus /></el-icon>
          </el-upload>
          <el-button @click="updateAvatar" v-if="isUpdateAvatar"
            >Submit</el-button
          >
        </div>
      </template>
    </Popup>
    <Popup title="My Username" ref="updateNicknameRef">
      <template #content>
        <div class="update-username-content">
          <el-input v-model="nickName" clearable />
          <el-button @click="updateNickname">Submit</el-button>
        </div>
      </template>
    </Popup>
    <el-dialog v-model="dialogVisible">
      <img
        class="sell-preview-images"
        :src="dialogImageUrl"
        alt="Preview Image"
        style="width: 100%;"
      />
    </el-dialog>
  </div>
</template>
<script>
import {
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "@vue/runtime-core";
import { ElNotification } from "element-plus";
import {
  getUserInfoApi,
  updateNicknameApi,
  updateAvatarApi,
} from "../../../api/index";
import Popup from "../../../components/popupView.vue";
import bus from "../../../utils/eventBus";
import md5 from "js-md5";
import ObsClient from "@/utils/obs/dist/esdk-obs-browserjs.3.22.3.min.js";
import { randomFour } from "@/utils/utils";

export default defineComponent({
  name: "MyProfile",
  components: { Popup },
  setup() {
    onMounted(() => {
      getUserInfo();
    });
    const updateAvatarRef = ref(null);
    const nickName = ref("");
    const updateNicknameRef = ref(null);
    const state = reactive({
      userInfoData: {},
      uploadObj: {
        size: 0,
        uidList: [],
        imagesUrlList: [],
      },
    });
    // 打开修改用户名弹框
    const openUpdateUsername = () => {
      nickName.value = state.userInfoData.nickname;
      updateNicknameRef.value.open();
    };
    // 修改用户名
    const updateNickname = () => {
      let data = {
        token: localStorage.getItem("token"),
        nickname: nickName.value,
      };
      updateNicknameApi(data).then((res) => {
        if (res.data.success) {
          ElNotification({
            title: "Tips",
            message: "Success",
            type: "success",
          });
          updateNicknameRef.value.close();
          bus.emit("updateUserInfoSuccess");
          nextTick(() => {
            getUserInfo();
          });
        }
      });
    };
    const openUpdateAvatar = () => {
      updateAvatarRef.value.open();
    };
    const uploadLoading = ref(false);
    const isUpdateAvatar = ref(false);
    const dialogVisible = ref(false);
    const dialogImageUrl = ref("");
    // 上传图片到华为云
    const uploadObs = (e) => {
      // console.log(e);
      uploadLoading.value = true;
      isUpdateAvatar.value = false;
      state.uploadObj.size++;
      let deviceNo = md5(localStorage.getItem("device_no")).substring(0, 8);
      let currentDate = new Date() * 1000;
      let obsKey =
        "cdkey/" + deviceNo + "/" + currentDate + randomFour() + ".png";
      // console.log(obsKey);

      var obsClient = new ObsClient({
        access_key_id: "JG1WRK9TKWI1JFEF6URX", // 你的ak
        secret_access_key: "xLQrYaQjAtIIC4SQfVfZrhS2LjvAKqzYoDgQqqzC", // 你的sk
        server: "https://obs.af-south-1.myhuaweicloud.com", // 你的endPoint
        timeout: 5000,
      });
      obsClient.putObject(
        {
          Bucket: "yhobject", // 桶名
          Key: obsKey, // 路径 + 文件名
          SourceFile: e.raw,
        },
        function(err, result) {
          if (err) {
            console.error("Error-->" + err);
            uploadLoading.value = false;
            isUpdateAvatar.value = false;
          } else {
            // console.log(result);
            console.log("Status-->" + result.CommonMsg.Status);
            if (result.CommonMsg.Status === 200) {
              state.uploadObj.uidList.push(e.uid);
              state.uploadObj.imagesUrlList.push(
                "https://yhobject.obs.af-south-1.myhuaweicloud.com/" + obsKey
              );
              // console.log("uidList:", state.uploadObj.uidList);
              // console.log("imagesUrlList:", state.uploadObj.imagesUrlList);
              state.uploadObj.size--;
              if (state.uploadObj.size === 0) {
                uploadLoading.value = false;
                isUpdateAvatar.value = true;
                Notification({
                  title: "Tips",
                  message: "Upload Success",
                  type: "success",
                });
              }
            }
          }
        }
      );
    };
    const handleRemove = (e) => {
      // 图片所在数组的下标
      let index = state.uploadObj.uidList.indexOf(e.uid);
      console.log(e);
      // 根据下标删除对应图片
      state.uploadObj.uidList.splice(index, 1);
      state.uploadObj.imagesUrlList.splice(index, 1);
      if (state.uploadObj.imagesUrlList.length === 0) {
        isUpdateAvatar.value = false;
      }
    };
    const handleExceed = () => {
      ElNotification({
        title: "Tips",
        message: "No More than 1 at a time",
        type: "error",
      });
    };
    const handlePictureCardPreview = (e) => {
      // console.log(e);
      dialogImageUrl.value = e.url;
      dialogVisible.value = true;
    };
    const updateAvatar = () => {
      let data = {
        token: localStorage.getItem("token"),
        avatar: state.uploadObj.imagesUrlList.join(","),
      };
      updateAvatarApi(data).then((res) => {
        console.log("updateAvatarApi：", res);
        if (res.data.success) {
          ElNotification({
            title: "Tips",
            message: "Success",
            type: "success",
          });
          updateAvatarRef.value.close();
          bus.emit("updateUserInfoSuccess");
          nextTick(() => {
            getUserInfo();
          });
        }
      });
    };
    const userInfoLoading = ref(false);
    const getUserInfo = () => {
      userInfoLoading.value = true;
      // 没有就重新请求
      getUserInfoApi({ token: localStorage.getItem("token") }).then((res) => {
        console.log("getUserInfoApi：", res);
        if (res.data.success) {
          if (res.data.data) {
            localStorage.setItem("userInfo", JSON.stringify(res.data.data));
            state.userInfoData = res.data.data;
            nickName.value = res.data.data.username;
          }
          userInfoLoading.value = false;
        } else {
          userInfoLoading.value = false;
          ElNotification({
            title: "Tips",
            message: res.data.msg,
            type: "error",
          });
        }
      });
    };
    return {
      uploadLoading,
      dialogVisible,
      dialogImageUrl,
      isUpdateAvatar,
      updateAvatarRef,
      nickName,
      updateNicknameRef,
      openUpdateAvatar,
      uploadObs,
      handleRemove,
      handleExceed,
      handlePictureCardPreview,
      updateAvatar,
      openUpdateUsername,
      updateNickname,
      userInfoLoading,
      ...toRefs(state),
    };
  },
});
</script>

<style lang="less" scoped>
.set-profile-container {
  padding: 20px;
  color: #333333;
  .set-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f5f5f5;
  }
  .set-profile-photo {
    .set-profile-avatar {
      display: flex;
      align-items: center;
      .el-image {
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }
      .profile-photo {
        margin-left: 10px;
        font-size: 16px;
      }
    }
  }
  .set-username {
    .set-profile-username {
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      .profile-username {
        color: #999999;
        font-weight: 500;
        font-size: 14px;
      }
    }
  }
  .btn-edit {
    background-color: #03004d;
    border-radius: 12px;
    color: #ffffff;
  }
  .update-username-content {
    padding: 20px;
    :deep(.el-input__inner) {
      border-radius: 12px;
    }
    .el-button {
      margin-top: 20px;
      background-color: #03004d;
      border-radius: 12px;
    }
  }
}
</style>
